import {
	defineStore
} from 'pinia';
import storage from "@/utils/storage.js";
import {
	Authorized
} from "@/api/auth.js";
import {
	UserInfo
} from "@/api/user.js";
import {
	WalletBalance
} from "@/api/wallet.js";
import {
	appSystemInfo
} from "@/app.config.js";
import {
	ShopCartNum
} from "@/api/shopping.js"
import {
	useLetterStore
} from "@/stores/letter.js"
import {
	showToast
} from '../utils/utils';
import {
	Log
} from '@antv/f2/es/types';
import md5 from 'blueimp-md5';


const TokenKey = 'token';
const loginForm = {
	client_id: appSystemInfo.clientId,
	client_secret: appSystemInfo.clientSecret,
	channelType: appSystemInfo.channelType,
	// #ifndef H5
	appId: 'wxb080a4db32967a93',
	// #endif
	// grant_type: 'password',
	// #ifndef H5
	grant_type: 'bus_app_auth',
	// #endif
	// #ifdef H5
	grant_type: 'member_auth',
	// #endif
	platCode: 0
}

export const useUserStore = defineStore('user', {
	state: () => {
		const token = storage.get(TokenKey);
		return {
			token,
			hasLogin: !!token,
			userInfo: {},
			shopCartNum: 0,
		}
	},
	actions: {
		onSetToken(token) {
			this.token = token;
			this.hasLogin = !!token;
			storage.set(TokenKey, token);
		},
		onRemoveToken() {
			this.token = '';
			this.hasLogin = false;
			storage.remove(TokenKey);
		},
		//获取购物车数量
		onGetShopCartNum() {
			return ShopCartNum().then(res => {
				this.shopCartNum = res;
			})
		},
		// 修改密码忘记密码
		onChangeLoginPassword(account, code, password, area) {
			return this.onLogin({
				...loginForm,
				signMode: 12,
				...(area ? { phone: account, area } : { mail: account }),
				code: md5(password),
				validCode: code,
			})
		},
		//密码登录
		onPasswordLogin(account, code, invitCode, area) {
			return this.onLogin({
				...loginForm,
				signMode: 6,
				...(area ? { phone: account, area } : { mail: account }),
				code: md5(code),
				invitCode
			})
		},
		//手机号登录
		onPhoneLogin(phone, code, invitCode, area) {
			return this.onLogin({
				...loginForm,
				signMode: 1,
				phone,
				validCode: code,
				invitCode,
				area
			})
		},
		
		//邮箱登录
		onEmailLogin(mail, code, invitCode) {
			return this.onLogin({
				...loginForm,
				signMode: 11,
				mail,
				validCode: code,
				invitCode,
			})
		},
		
		//微信登录
		onWeChatLogin(callBack) {
			uni.login({
				provider: 'weixin',
				onlyAuthorize: true,
				success: async loginRes => {
					console.log(loginRes);
					const res = await this.onLogin({
						...loginForm,
						code: loginRes.code,
						signMode: 3
					});
					if (res.body.isBind == 1) {
						this.onGetUserInfo();
						this.onGetShopCartNum();
					} else {
						this.onSetToken(res.tokenHead + res.token);
						storage.set('refreshToken', res.refreshToken);
					}
					callBack && callBack(res);
				},
				fail: err => {
					console.log(err)
				}
			});
		},
		//一键登录
		async onFastLogin(token, callBack) {
			try {
				const res = await this.onLogin({
					...loginForm,
					signMode: 5,
					code: token
				});
				this.onGetUserInfo();
				this.onGetShopCartNum();
				callBack && callBack(res);
			} catch (err) {
				console.log(err);
				showToast('登录失败，请尝试其他登陆方式');
				uni.navigateTo({
					url: '/pages/Auth/Index'
				})
				//TODO handle the exception
			}
		},
		//微信小程序授权
		onMinWxLogin() {
			return new Promise((resolve, reject) => {
				uni.login({
					success: async loginInfo => {
						try {
							const res = await this.onLogin({
								...loginForm,
								signMode: 3,
								code: loginInfo.code,
								invitCode: storage.get('inviteCode') || ''
							})
							resolve(res);
						} catch (e) {
							reject(e);
							//TODO handle the exception
						}
					},
					fail: reject
				})
			})
		},
		// 获取用户信息
		onGetUserInfo() {
			return new Promise(async (resovle, reject) => {
				try {
					const userInfo = await UserInfo()
					this.hasLogin = true;
					this.userInfo = {
						...this.userInfo,
						...userInfo
					};
					const wallet = await WalletBalance();
					this.hasLogin = true;
					this.userInfo = {
						...this.userInfo,
						...userInfo,
						...wallet
					};
					// 站内信实时通知：登录态确定后建立 WebSocket（仅 H5）
					useLetterStore().connect(this.userInfo.saasId);
					resovle();
				} catch (e) {
					//TODO handle the exception
					reject();
				}
			})
		},
		//登录
		onLogin(params) {
			return Authorized(params).then(res => {
				if (res.body && res.body.isBind == 1) {
					this.onSetToken(res.tokenHead + res.token);
					storage.set('refreshToken', res.refreshToken);
				}else if(res.body && res.body.isBind == 0){
					this.onSetToken(res.tokenHead + res.token);
					storage.set('refreshToken', res.refreshToken);
				}
				return res;
			})
		},
		//重置Token
		onRefreshToken() {
			return this.onLogin({
				...loginForm,
				grant_type: 'refresh_token',
				refresh_token: storage.get('refreshToken'),
			}).then(res => {
				this.onSetToken(res.tokenHead + res.token);
				storage.set('refreshToken', res.refreshToken);
				return res;
			})
		},
		// 注册
		onRegister({ phone, code, password, invitCode, area, name }) {
			const isEmail = phone && phone.includes('@');
			return this.onLogin({
				...loginForm,
				signMode: isEmail ? 11 : 1,
				...(isEmail ? { mail: phone } : { phone, area }),
				validCode: code,
				code: md5(password),
				invitCode: invitCode || '',
				name: name || ''
			}).then(res => {
				this.onGetUserInfo();
				this.onGetShopCartNum();
				return res;
			});
		},
		//退出登录
		onLoginOut() {
			this.hasLogin = false;
			this.userInfo = {};
			this.shopCartNum = 0;
			this.onRemoveToken();
			storage.set('refreshToken', '');
			// 断开站内信 WebSocket（仅 H5）
			useLetterStore().disconnect();
		}
	}
});
